import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { useOrgController } from "../../auth/org-provider";
import { CompanyStage } from "tekkr-common/dist/enums";

interface Input {
    update: {
        techOrgSize?: number;
        companySize?: number;
        stage?: CompanyStage;
    };
}

interface Options {
    onSuccess?: () => void;
}

export function useUpdateOrgMetaMutation(options: Options) {
    const { refetch: refetchOrg } = useOrgController();
    return useMutation({
        mutationFn: async (input: Input) => {
            await apiClient.updateOrgMeta({
                body: input.update,
            });
            await refetchOrg();
        },
        onSuccess: options?.onSuccess,
    });
}
